
import { OSTipoViewModel } from './../../domain/viewmodels.models';
import { Component, OnInit, AfterContentInit, ViewChild, ElementRef, LOCALE_ID } from '@angular/core';
import { AreaTecnicaService } from 'src/app/pages/cadastros/areatecnica/areatecnica.service';
import { RotinaService } from 'src/app/pages/cadastros/rotina/rotina.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { FuncionarioService } from 'src/app/pages/cadastros/funcionario/funcionario.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OSService } from 'src/app/services/os-service';
import { OS } from 'src/app/models/os.model';
import { EmpreiteiraService } from 'src/app/pages/cadastros/empreiteira/empreiteira.service';
import { Atividade } from 'src/app/models/atividade.model';
import { AtividadeService } from 'src/app/pages/cadastros/atividade/atividade.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { CommandResult } from '../../domain/commandResult';
import { SCAMP_API_RPT, APP_SETTINGS } from 'src/environments/environment';

//emitir-os-automatica
@Component({
  selector: 'app-emitir-os-automatica',
  templateUrl: './emitir-os-automatica.component.html',
  styleUrls: ['./emitir-os-automatica.component.scss'],
  providers: [AreaTecnicaService, RotinaService, FuncionarioService, OSService, EmpreiteiraService, AtividadeService]
})
export class EmitirOsAutomaticaComponent implements OnInit, AfterContentInit {



  public areasTecnicas: any[] = [];
  public resultadosPesquisa: any[] = [];
  public parametros: {} = null;
  public empreiteiras: any[] = [];
  public engenheiros: any[] = [];
  public encarregados: any[] = [];
  public atividades: Atividade[] = [];

  public totalOSsAGerar = 0;
  public OSs: OS[] = [];

  public validacaoDatas = '';
  public validacaoAreaTecnica = '';
  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;
  public nenhumResultado = false;
  

  public autorizacoes: UsuarioAutorizacoes;

  public form: FormGroup = null;
  @ViewChild('obterosmanual') obterosmanual: ElementRef;
  @ViewChild('imprimirEvidenciaDeFotos') imprimirEvidenciaDeFotos: ElementRef;

  constructor(
    private areasTecnicasService: AreaTecnicaService,
    private rotinaService: RotinaService,
    private funcionarioService: FuncionarioService,
    private osService: OSService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private empreiteiraService: EmpreiteiraService,
    private usuarioService: UsuarioService

  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('emitir-os-automatica');
  }

  ngOnInit() {
    this.getAreasTecnicas();
    this.resetForm();
    this.getEmpreiteiras();
  }

  public getAreasTecnicas() {
    this.areasTecnicasService.list().subscribe((response: any) => { this.areasTecnicas = response; });
  }

  public getEmpreiteiras() {
    this.empreiteiraService.getEmpreiteiras().subscribe((response) => {
      this.empreiteiras = response;
      if (this.empreiteiras.length == 1) {
        this.form.get('empreiteiraId').setValue(this.empreiteiras[0].id);
        this.getEngenheirosEEncarregadosPorEmpreiteira(this.empreiteiras[0].id);
      }


    });
  }

  public getEngenheirosEEncarregadosPorEmpreiteira(id: number) {

    if (Number(id) === 0) {
      this.engenheiros = [];
      this.encarregados = [];
      return;
    }

    this.funcionarioService.getEngenheirosPorEmpreiteira(id).subscribe((response) => {
      this.engenheiros = response;

      if (this.engenheiros.length == 1) {
        this.form.get('engenheiroResponsavelId').setValue(this.engenheiros[0].id)
      } else {
        this.form.get('engenheiroResponsavelId').setValue('');
      }

    });

    this.funcionarioService.getEncarregadosPorEmpreiteira(id).subscribe((response) => {
      this.encarregados = response;
    });
  }


  public resetForm(): void {
    this.form = new FormGroup(
      {
        empreiteiraId: new FormControl('', Validators.required),
        encarregadoResponsavelId: new FormControl('', Validators.required),
        engenheiroResponsavelId: new FormControl('', Validators.required),
      }
    );


    if (this.empreiteiras.length == 1) {
      this.form.get('empreiteiraId').setValue(this.empreiteiras[0].id);
    }

    if (this.engenheiros.length == 1) {
      this.form.get('engenheiroResponsavelId').setValue(this.engenheiros[0].id)
    } else {
      this.form.get('engenheiroResponsavelId').setValue('');
    }


  }

  validaDatas(dataInicial, dataFinal) {

    this.validacaoDatas = '';

    if (dataInicial === '' && dataFinal === '') {
      this.validacaoDatas = 'O período deve ser informado';
    }

    if (!(dataInicial === '' && dataFinal === '')) {
      if (dataInicial === '' && dataFinal !== '') { this.validacaoDatas = 'Informe a Data Inicial'; }
      if (dataInicial !== '' && dataFinal === '') { this.validacaoDatas = 'Informe a Data Final'; }
      if (Date.parse(dataFinal) < Date.parse(dataInicial)) { this.validacaoDatas = 'A data final deve ser maior que data inicial'; }
    }

  }

  validaAreaTecnica(areaTecnica) {
    this.validacaoAreaTecnica = '';
    if (areaTecnica === '') {
      this.validacaoAreaTecnica = 'Informe uma Área Técnica';
    }
  }

  validaParametros(parametros: any) {

    this.validaDatas(parametros.dataInicial, parametros.dataFinal);
    this.validaAreaTecnica(parametros.areaTecnicaId);

    return this.validacaoAreaTecnica === '' && this.validacaoDatas === '';

  }

  buscar(parametros: any) {

    if (this.validaParametros(parametros)) {

      this.parametros = parametros;

      this.isProcessing = true;
      this.nenhumResultado = false;

      this.rotinaService.getRotinaEquipamento(parametros).subscribe(response => {
      

        this.resultadosPesquisa = response;

        if (this.resultadosPesquisa.length === 0) {
          this.nenhumResultado = true;
        } 
        this.isProcessing = false;
      },
        (error: any) => {
          this.showError(error);
        });
    }

  }

  clearParametros() {
    const selects = document.getElementsByTagName('select');
    const inputs = document.getElementsByTagName('input');

    Array.from(inputs).forEach(i => { if (i.value !== '' && i.classList.contains('parametro')) { i.value = ''; } });
    Array.from(selects).forEach(s => { if (s.value !== '' && s.classList.contains('parametro')) { s.value = ''; } });

    this.validacaoDatas = '';
    this.validacaoAreaTecnica = '';
    this.resultadosPesquisa = [];

  }


  reset() {


    // reseta as variaveis de controle
    this.validacaoDatas = '';
    this.validacaoAreaTecnica = '';
    this.resultadosPesquisa = [];
    this.nenhumResultado = false;
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    // this.parametros = null;

    this.totalOSsAGerar = 0;
    this.OSs = [];
    this.atividades = [];
    this.resetForm();

  }


  public showError(error: any) {

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }


  selecionarRotinaEquipamento(atividadeId: number) {
    const selecionado = this.resultadosPesquisa.find(t => t.atividadeId === atividadeId);
    selecionado.marcado = !selecionado.marcado;
    this.totalOSsAGerar = this.resultadosPesquisa.filter(t => t.marcado === true).length;

  }

  selecionarTodos() {
    this.resultadosPesquisa.forEach(s => s.marcado = true);
    this.totalOSsAGerar = this.resultadosPesquisa.filter(t => t.marcado === true).length;

  }

  selecionarNenhum() {
    this.resultadosPesquisa.forEach(s => s.marcado = false);
    this.totalOSsAGerar = 0;

  }


  //submit()
  gerarOSs() {

    this.isProcessing = true;

    // Perguntar a Vanessa como gera OS Automatica
    this.resultadosPesquisa.forEach(rp => {

     

      if (rp.marcado === true) {

        const atividade = new Atividade(rp.atividadeId, rp.proximaExecucao, rp.espacamento);
        //Todo: Enteder porque a prioridade tem que ser 2 ao criar uma OS automática


        this.OSs.push(new OS(0, 
          'A', 
          'PR', 
          'Rotina automática', 
          rp.rotinaDescricao, 
          null,
          null, 
          null, 
          null, 
          1, 
          this.form.get('empreiteiraId').value,
          this.form.get('encarregadoResponsavelId').value, 
          this.form.get('engenheiroResponsavelId').value,
          rp.equipamentoId, 
          rp.atividadeId, 
          rp.localId, 
          atividade, 
          APP_SETTINGS.prioridadeDefaultOSPreventiva, 
          rp.areaTecnicaId,
          "1"
        ));

      }
    });


    this.modalService.dismissAll();

    this.OSs.sort((a, b) => {

      const data1 = new Date(a.atividade.proximaExecucao.split('T')[0]);
      const data2 = new Date(b.atividade.proximaExecucao.split('T')[0]);
      
      if (data1 < data2) return -1
      if (data1 > data2) return 1
      return 0;
    } );


    this.osService
      .gerarOSs(this.OSs)
      .subscribe(
        (retorno: any) => {

          this.isProcessing = false;
          let msg = '<b>OSs</b> geradas';

          if (this.OSs.length === 1) {
            msg = '<b>OS</b> gerada';
          }

          let msgPdf = '';

          if ((this.obterosmanual.nativeElement.checked as boolean) == true) {
            msgPdf = '<br />Aguarde... PDF(s) sendo gerado(s)'
          }


          this.toastr.success(`${msg} com sucesso${msgPdf}`);


          const imprimirEvidenciaDeFotos = (this.imprimirEvidenciaDeFotos.nativeElement.checked ? "S" : "N")

          let OSsTipo: OSTipoViewModel[] = [];
          if ((this.obterosmanual.nativeElement.checked as boolean) == true) {

            retorno.data.forEach((d) => {
              
              OSsTipo.push({
                oSId: d.id,
                tipoOSFilha: 1,
                fileNamePdf: '',
                imprimirEvidenciaDeFotos: imprimirEvidenciaDeFotos
              })

            });

            this.osService.imprimirOSMerge(OSsTipo).subscribe((response) => {

              if (response.success === true) {

                if (response.nenhumResultado === false) {
                  window.open(
                    `${SCAMP_API_RPT.root}${response.pathRpt}`,
                    '_blank',
                    'width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no'
                  );

                } else {
                  this.toastr.warning(response.msgErro);
                }
              } else {
                this.toastr.error(response.msgErro);
              }
            },
              (err: any) => {
                this.toastr.error('Não foi possível se conectar ao servidor de relatórios', 'Erro de Conexão');
              });
          }



          this.reset();
          this.buscar(this.parametros);
        },
        (error) => {
          this.showError(error);
        },
      );
  }


}
